import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import moment from 'moment';

import { useCheckLastUpdate } from '../../hooks/use-check-last-update';
import './styles.scss';

type checkLastUpdateProps = {
  lastUpdate: string;
  isLoading?: boolean;
  isClickable?: boolean;
};

export const CheckLastUpdate = ({
  lastUpdate = '',
  isLoading = false,
  isClickable,
}: checkLastUpdateProps) => {
  const dateIsOld = useCheckLastUpdate(lastUpdate);

  const lastUpdateFormatted = lastUpdate
    ? moment.parseZone(lastUpdate).format('DD MMM YYYY - HH:mm') + ' UTC'
    : '-';

  return (
    <div className={`portfolio-management-last-update ${isClickable ? 'time-clickable' : ''}`}>
      <span>Last update:</span>

      {isLoading ? (
        <div className="time-container loading">
          <CircularProgress size={12} />
        </div>
      ) : (
        <div className={`time-container ${dateIsOld ? 'old-time' : ''}`}>
          <FontAwesomeIcon icon={faCalendar} className="icon" />
          <span className="timestamp">{lastUpdateFormatted}</span>
        </div>
      )}
    </div>
  );
};
